module.exports = __webpack_public_path__ + "static/Schalldaempfer-2-a28b674ab370eb400de407b7564687b6.jpg";